import { mapGetters, mapActions } from 'vuex'

const systemMessageModuleName = 'systemmessage'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(systemMessageModuleName, {
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff',
      snapshots: 'snapshots',
      returnRoute: 'returnRoute'
    }),
    ...mapGetters(['debounceDelay'])
  },
  watch: {

  },
  methods: {
    ...mapActions(systemMessageModuleName, [
      'getStoreItem',
      'addStoreItem',
      'clearSnapshots',
      'saveSnapshot',
      'saveInitialSnapshots',
      'setReturnRoute'
    ])
  }
}
